import $ from 'jquery';
import 'modaal';

export default class Messages {
  constructor(element) {
    $(document.body).modaal({
      accessible_title: 'The website reported these messages',
      custom_class: 'modaal-messages',
      content_source: `#${element.id}`,
      start_open: true,
    });
  }
}
